export const Cleaners = {
	texto: (v: string) => v.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑàèìòùÀÈÌÒÙäëïöüÄËÏÖÜâêîûôÂÊÎÛÔçÇ ]/g, ''),
	numerico: (v: string) => v.replace(/\D/g, ''),
	dni(v: string) {
		const val = v.replace(/[^0-9a-zA-Z]/g, '').substring(0, 9).toUpperCase();
		const numbersPart = val.substring(0, 8).replace(/\D/g, '');
		const letterPart = val.substring(8, 9).replace(/[^A-Z]/g, '');
		return (numbersPart + letterPart)?.toUpperCase();
	},
	nie(v: string) {
		const val = v.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().substring(0, 9);
		if (!val) return '';
		const inicio = val.charAt(0).replace(/[^XYZ]/g, ''); 
		const medio = val.substring(1, 8).replace(/\D/g, '');
		const fin = val.substring(8, 9).replace(/[^A-Z]/g, '');
		return (inicio + medio + fin)?.toUpperCase();
	},
	cp: (v: string) => v.replace(/\D/g, '').substring(0, 5),
	email: (v: string) => v.replace(/\s/g, '').replace(/[^a-zA-Z0-9.@_-]/g, ''),
	via(v: string) {
		return v
			.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑàèìòùÀÈÌÒÙäëïöüÄËÏÖÜâêîûôÂÊÎÛÔçÇ& /ºª.-]/g, '')
			.substring(0, 150);
	},
	alfanumericoSimple(v: string) {
		return v
			.replace(/[^a-zA-Z0-9 ]/g, '');
	},
	complementoDireccion(v: string) {
		return v
			.replace(/[<>;]|script/gi, ''); 
	},
	sinEspacios: (v: string) => v.replace(/\s+/g, ''),
};